<template>
    <div class="page">
        <div class="t1" v-if="isWechat">绑定手机</div>
        <div class="t1" v-else>登录/注册</div>
        <div class="t2">绑定手机享受更多服务</div>
        <div class="t0" v-if="tip">
            当前集数已播放完毕，邀请您登录/注册福音TV会员
            <br />避免失联，随时在线
        </div>
        <div class="t0" v-else>
            邀请您登录/注册福音影视网（福音TV）会员
            <br />避免失联，随时在线
        </div>
        <div>
            <div class="input">
                <span @click="areaVisible=true">+{{area}}</span>
                <input placeholder="请输入您的手机号" v-model="phone" maxlength="11" />
                <a href="javascript:;" class="icon icon-close" @click="phone=''" v-if="phone"></a>
            </div>
        </div>
        <div>
            <div class="input">
                <span>验证码</span>
                <input placeholder="请输入获取的验证码" v-model="code" maxlength="6" />
                <a href="javascript:;" v-if="cold>0">{{cold}}s</a>
                <a href="javascript:;" @click="onSendCode" v-else>发送验证码</a>
            </div>
        </div>
        <div class="btn">
            <a class="submit" href="javascript:;" @click="onSubmit" v-if="isWechat">确认绑定</a>
            <a class="submit" href="javascript:;" @click="onSubmit" v-else>登录/注册</a>
        </div>
        <div class="btn" v-if="ignore">
            <a class="off" href="javascript:;" @click="onCancel">下次再说</a>
        </div>
        <div class="t5">
            手机号将作为您的会员账户，可以在福音TV app
            <br />上直接登录，笔记、收藏云端在线，多端同步。
        </div>
        <div class="download">
            <a href="http://www.fytvapp.com">
                点击下载福音TV App
                <br />(暂不绑定)
            </a>
        </div>
        <div class="areas" ref="areas" v-if="areaVisible">
            <div v-for="(j,i) in areas" :key="i">
                <div class="areas-title">{{i}}</div>
                <a href="javascript:;" class="areas-item" v-for="(item,k) in areas[i]" :key="k" @click="onChooseArea(item)">
                    <span>{{item.n}}</span>
                    <span>{{item.c}}</span>
                </a>
            </div>
            <div class="contents">
                <a href="javascript:;" v-for="(j,i) in areas" :key="i" @click="onScrollTo(i)">{{i}}</a>
            </div>
        </div>
    </div>
</template>
<script>
import { Toast } from 'mint-ui'
import areas from './areas'
export default {
    data() {
        return {
            phone: '',
            code: '',
            cold: 0,
            ignore: false,
            areas: areas,
            area: '86',
            areaVisible: false,
            isWechat: false
        }
    },
    computed: {
        tip() {
            return this.$route.query.tip
        }
    },
    mounted() {
        this.isWechat = window.isWechat
        this.$service.user.isSettingReady(this.onReady)
    },
    methods: {
        onReady() {
            this.ignore = this.$service.user.setting.h5_bind_mobile_ignore
        },
        async onSendCode() {
            if (!this.phone) {
                return Toast('请输入手机号')
            }
            if (!/^1\d{10}$/.test(this.phone)) {
                return Toast('手机号码格式不正确')
            }
            await this.$service.user.getPhoneCode(this.phone)
            if (this.cold > 0) {
                return
            }
            this.cold = 60
            this.onTimer()
        },
        onTimer() {
            this.cold--
            if (this.cold > 0) {
                setTimeout(this.onTimer, 1000);
            }
        },
        async onSubmit() {
            if (!this.phone) {
                return Toast('请输入手机号')
            }
            if (!/^1\d{10}$/.test(this.phone)) {
                return Toast('手机号码格式不正确')
            }
            if (!this.code) {
                return Toast('请输入验证码')
            }
            if (this.isWechat) {
                await this.$service.user.bindPhone(this.phone, this.code, this.area)
            } else {
                await this.$service.user.loginByPhone(this.phone, this.code, this.area)
            }
            if (await this.$service.user.checkUserState(this, true)) {
                this.$service.user.goReturn(this)
            }
        },
        onCancel() {
            this.$service.user.goReturn(this, true)
        },
        onScrollTo(k) {
            let y = 0
            let i = Object.keys(this.areas).findIndex(i => {
                if (i == k) {
                    return true
                } else {
                    y += (this.areas[i].length + 1) * 40
                    return false
                }
            })
            this.$refs.areas.scrollTop = y
        },
        onChooseArea(item) {
            this.area = item.c
            this.areaVisible = false
        }
    }
}
</script>
<style lang="scss" scoped>
.page {
    padding-top: 40px;
    text-align: center;
}
.qrcode {
    img {
        width: 150px;
        height: 150px;
        box-shadow: 0 1px 10px #cccccc;
    }
}
.t0 {
    color: $color-red;
    line-height: 1.2;
    margin-bottom: 10px;
}

.t1 {
    font-size: 18px;
    color: #48b1e3;
}
.t2 {
    font-size: 12px;
    color: #a9a9a9;
    margin-bottom: 40px;
}
.input {
    margin: auto;
    display: flex;
    align-items: center;
    width: 300px;
    height: 40px;
    border-bottom: 1px solid #48b1e3;
    margin-bottom: 30px;
    span {
        width: 60px;
        text-align: center;
        color: #666;
    }
    input {
        flex: 1;
        padding: 0 10px;
        height: 30px;
        min-width: 10px;
    }
    a {
        color: #48b1e3;
        text-align: right;
        width: 80px;
    }
}
.btn {
    margin-top: 30px;
    a {
        display: inline-block;
        width: 300px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 16px;
        color: white;
        border-radius: 100px;
        background-color: #ccc;
    }
    .submit {
        background-color: #48b1e3;
    }
}
.t5 {
    font-size: 12px;
    color: #404040;
    margin-top: 60px;
}
.download {
    margin-top: 30px;
    font-size: 16px;
    color: red;
}
.areas {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: white;
    text-align: left;
    .areas-title {
        background-color: #f4f4f4;
        padding: 0 15px;
        height: 40px;
        line-height: 40px;
        border-bottom: $style-border;
    }
    .areas-item {
        padding: 0 30px 0 15px;
        height: 40px;
        line-height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: $style-border;
    }
    .contents {
        position: fixed;
        top: 50%;
        right: 0;
        transform: translate(0, -50%);
        background-color: white;
        a {
            display: block;
            color: $color-blue;
        }
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?b9676d3a